import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=06fb5ef4&"
import script from "./documentList.vue?vue&type=script&lang=js&"
export * from "./documentList.vue?vue&type=script&lang=js&"
import style0 from "./documentList.vue?vue&type=style&index=0&id=06fb5ef4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports